<template>
    <a class="cp-news-hub-featured-article" :href="this.featuredArticle.url">
        <div class="cp-news-hub-featured-article-img-container">
            <img class="cp-news-hub-featured-article-img" :src="this.GetImageCropper(this.featuredArticle.imageUrl)"/>
        </div>

        <div class="cp-news-hub-featured-article-content-container">
            <div class="cp-news-hub-featured-article-content-date">
                {{ this.FormatDate(this.featuredArticle.publishDate) }}
            </div>

            <div class="cp-news-hub-featured-article-content">
                <h2 class="featured-article-title">{{ this.featuredArticle.title }}</h2>
                <p class="featured-article-author">{{ this.featuredArticle.author }}</p>
            </div>

            <div class="cp-news-hub-featured-article-content-description">
                <p class="featured-article-description">{{ this.featuredArticle.description }}</p>
            </div>
        </div>
    </a>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
    props: {
		articleId: String,
	},
    components:{},
    data() {
        return {
            formattedDate: null,
            featuredArticle:null,
        };
    },

    created () {
        axios.get(`/api/NewsApi/GetFeaturedArticle/${this.articleId}`).then((response) => {
            this.featuredArticle = response.data[0];
        })
    },

    methods : {
		FormatDate(date) {
			return moment(String(date)).format("DD MMM YY");
		},
        GetImageCropper(image) {
			if (image != null) {
				var value = 0;
				var newWidth = null;
				var newHeight = null;
				var cropLeft = 0.5;
				var cropTop = 0.5;

				if (window.screen.width <= 320) {
					value = window.screen.width / 320;
					newWidth = (value * 500).toFixed(0);
					newHeight = (value * 300).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				} else if (window.screen.width <= 767) {
					value = window.screen.width / 767;
					newWidth = (value * 500).toFixed(0);
					newHeight = (value * 300).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				} else if (window.screen.width <= 1279) {
					value = window.screen.width / 1279;
					newWidth = (value * 416).toFixed(0);
					newHeight = (value * 250).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				} else if (window.screen.width <= 1535) {
					value = window.screen.width / 1535;
					newWidth = (value * 500).toFixed(0);
					newHeight = (value * 300).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				} else if (window.screen.width <= 1920) {
					value = window.screen.width / 1920;
					newWidth = (value * 500).toFixed(0);
					newHeight = (value * 300).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				} else {
					value = window.screen.width / 1920;
					newWidth = (value * 500).toFixed(0);
					newHeight = (value * 300).toFixed(0);
					return image + `?center=${cropTop},${cropLeft}&mode=crop&width=${newWidth}&height=${newHeight}&format=webp&quality=80&rnd=132945132427470000`;
				}
			}
		},
    }
}
</script>
